export var Method;
(function (Method) {
    Method["GET_DATA"] = "getData";
    Method["DATA_COUNT"] = "dataCount";
    Method["ALL_DATA"] = "allData";
    Method["OWNER"] = "owner";
})(Method || (Method = {}));
export var Encoding;
(function (Encoding) {
    Encoding["BYTES"] = "bytes";
    Encoding["UINT256"] = "uint256";
    Encoding["BYTES32_ARRAY"] = "bytes32[]";
    Encoding["ADDRESS"] = "address";
})(Encoding || (Encoding = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWV0aG9kLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3R5cGVzL01ldGhvZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQU4sSUFBWSxNQUtYO0FBTEQsV0FBWSxNQUFNO0lBQ2hCLDhCQUFvQixDQUFBO0lBQ3BCLGtDQUF3QixDQUFBO0lBQ3hCLDhCQUFvQixDQUFBO0lBQ3BCLHlCQUFlLENBQUE7QUFDakIsQ0FBQyxFQUxXLE1BQU0sS0FBTixNQUFNLFFBS2pCO0FBRUQsTUFBTSxDQUFOLElBQVksUUFLWDtBQUxELFdBQVksUUFBUTtJQUNsQiwyQkFBZSxDQUFBO0lBQ2YsK0JBQW1CLENBQUE7SUFDbkIsdUNBQTJCLENBQUE7SUFDM0IsK0JBQW1CLENBQUE7QUFDckIsQ0FBQyxFQUxXLFFBQVEsS0FBUixRQUFRLFFBS25CIn0=